module.exports = __webpack_public_path__ + "static/media/tooltip-exc-big.4608c075.svg";